import React from 'react';
import { Modal } from '../themes/nzf_2022';
import Spinner from '../choose-your-price/components/spinner';

const LoaderModal = ({ messageText='', secondaryMessageText }) => {
  return (
    <Modal parsedContent={ (
      <div className='flex flex-column flex-ai-center mx-auto pt-20 pb-56 w-11/12 sm+:max-w-8/12'>
          <Spinner altText={ messageText } />

          { messageText && <h2 className='text-xl color-black mt-8 text-center'>{ messageText }</h2> }

          { secondaryMessageText && <p className='mt-14 color-grey-20 mt-4 text-center'>{ messageText}</p> }
      </div>
    ) }
    />
  );
};

export default LoaderModal;
